export default{
    productos: [],
    productoSelec: null,
}

